import { usePathname, useSearchParams } from '@framework/next/navigation';
import cfrUrl from '@/creditflowresearch/infrastructure/url';
import config from '@creditflowresearch/config';
import usersUrl from '@users/url';

const useSignUpUrl = (): string => {
  const pathname = usePathname();
  const searchParams = useSearchParams()?.toString();
  const url = `${ pathname }${ searchParams ? `?${ searchParams }` : '' }`;
  const callbackUrl = cfrUrl.getPropagateCallbackUrl(url);

  return usersUrl.getRegisterUrl(callbackUrl, config.code);
};

export default useSignUpUrl;
